async function loadXlsx() {
  const XLSXModule = await import('xlsx');
  return XLSXModule.default ?? XLSXModule;
}

function normalizeWorkbookFilename(fileName) {
  return fileName.toLowerCase().endsWith('.xlsx') ? fileName : `${fileName}.xlsx`;
}

export const downloadSheetsAsExcel = async (fileName, sheets) => {
  const XLSX = await loadXlsx();
  const workbook = XLSX.utils.book_new();

  Object.entries(sheets).forEach(([sheetName, data]) => {
    const worksheet = XLSX.utils.json_to_sheet(Array.isArray(data) ? data : []);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  });

  XLSX.writeFile(workbook, normalizeWorkbookFilename(fileName));
};

export const downloadDataAsExcel = async (fileName, data) => {
  await downloadSheetsAsExcel(fileName, { Data: data });
};
